import React from "react";

const FormTextArea = ({ onChange, value, placeholder, name, rows, label }) => {
  return (
    <>
      {label && <p className="mb-1.5 text-xs text-monochrome-400">{label}</p>}
      <textarea
        name={name}
        placeholder={placeholder}
        className={`form-input w-full`}
        type="text"
        rows={rows}
        value={value}
        onChange={onChange}
      />
    </>
  );
};

export default FormTextArea;
